import RequestLoaderTriggerLogic from "./useRequestLoaderTrigger";

export const RequestLoaderTrigger = ({ children }) => {
  RequestLoaderTriggerLogic();

  return children;
};
